export const FETCH_PROJECT_REMINDER_MAILS_REQUEST = 'FETCH_PROJECT_REMINDER_MAILS_REQUEST'
export const FETCH_PROJECT_REMINDER_MAILS_SUCCESS = 'FETCH_PROJECT_REMINDER_MAILS_SUCCESS'
export const FETCH_PROJECT_REMINDER_MAILS_FALUIRE = 'FETCH_PROJECT_REMINDER_MAILS_FALUIRE'
export const SAVE_PROJECT_REMINDER_MAIL_REQUEST = 'SAVE_PROJECT_REMINDER_MAIL_REQUEST'
export const SAVE_PROJECT_REMINDER_MAIL_DONE = 'SAVE_PROJECT_REMINDER_MAIL_DONE'
